<template>

<div>

	<div class="page-header">
		<h1><lang labelKey="HEADER_SECTIONS"></lang></h1>
	</div>

	<div class="columns">

		<div class="col-main">

			<div v-if="isLoading" class="loadingContainer has-text-centered">
				<loading-indicator></loading-indicator>
			</div>

			<template v-if="!isLoading">

				<v-client-table name="tblSections" :data="sections" :columns="tblColumns" :options="tblOptions">

	                <!-- before table: FILTER OPTIONS -->
	                <template slot="beforeTable">

	                    <div class="columns is-marginless filters">

	                        <!--search -->
	                        <div class="column is-narrow">
	                            <div class="control has-icon search">
	                                <input class="input" type="text" v-model.trim="searchString" placeholder="Suchbegriff">
	                                <i class="fa fa-search" aria-hidden="true"></i>
	                            </div>
	                        </div>

	                    </div>

	                </template>

					<template slot="pageCount" slot-scope="props">

					</template>

					<template slot="delete" slot-scope="props">
						<pop-confirm :content="$t('CONFIRMATION-DELETE_SECTION')" icon="question-circle-o" :on-ok="function() { sectionDelete(props) }" :on-cancel="cancel">
							<span class="icon is-small"><i class="icon-ak-entfernen"></i></span>
						</pop-confirm>
					</template>

				</v-client-table>

				<!--
				<froala
					id="froala"
					ref="froala"
					:tag="'textarea'"
					:config="froalaConfig"
					v-model="test"
				></froala>
				-->



			</template>

		</div>

        <div class="col-aside">

			<affix :offset="0">
				<custom-button type="blue" name="SECTIONS_BTN-SECTION_ADD" icon="icon-ak-hinzufuegen" @click.native="sectionAdd"></custom-button>
			</affix>

		</div>

	</div>

</div>
</template>


<script>
import Vue from 'vue';
import { ClientTable, Event } from 'vue-tables-2';
Vue.use(ClientTable, {}, false, 'bulma');

// Require Froala Editor js file.
require("froala-editor/js/froala_editor.pkgd.min.js");

// Require german lang file
require("froala-editor/js/languages/de.js");

// Require Froala Editor css files.
require("froala-editor/css/froala_editor.pkgd.min.css");
require("froala-editor/css/froala_style.min.css");
// Import and use Vue Froala lib.
import VueFroala from "vue-froala-wysiwyg";
Vue.use(VueFroala);


export default {

	name: 'sections',

	components: {
		//draggable
		VueFroala
	},

	data() {

		return {
			test: null,
			froalaConfig: {

				key: "",
				linkAlwaysBlank: true,

				wordPasteModal: false,
				// wordPasteKeepFormatting: true,
				// pasteDeniedTags: ['b', 'strong', 'i', 'em'],
				htmlAllowedTags: [
					"br",
					"p",
					"b",
					"strong",
					"i",
					"em",
					"ul",
					"li",
					"table",
					"tbody",
					"tr",
					"td",
					"tfoot",
					"th"
				],
				// pastePlain: true,

				wordPasteKeepFormatting: false,
				heightMin: 200,
				heightMax: 1024,
				quickInsertTags: [],
				quickInsertButtons: false,
				language: "de",
				charCounterCount: false
			},
			isLoading: false,
			searchString: '',
			sections: [],
			tblColumns: ['name', 'topicName', 'color', 'delete'],
			tblOptions: {
				saveState: true,
				perPage: 25,
				orderBy: {
					ascending: true,
					column: 'sortorder'
				},
				headings: {
					name: function(h) {
						return <lang labelKey="SECTIONS_TBL_HEADER-LABELKEY"></lang>
					},
					topicName: function(h) {
						return <lang labelKey="SECTIONS_TBL_HEADER-TOPICNAME"></lang>
					},
					pageCount: function(h) {
						return <lang labelKey="SECTIONS_TBL_HEADER-PAGE_COUNT"></lang>
					},
					color: function(h) {
						return <lang labelKey="SECTIONS_TBL_HEADER-COLOR"></lang>
					},
                    delete: function(h) {
						return <lang labelKey="SECTIONS_TBL_HEADER-DELETE"></lang>
					}
				},
				filterByColumn: false,
				filterable: false,
				sortable: ['name'],
				sortIcon: {
					base:'fa',
					up:'fa-sort-up',
					down:'fa-sort-down',
					is:'fa-sort'
				},
				texts: {
					filter: 'Filter Ergebnisse:',
					filterPlaceholder: 'Suche',
					limit: 'Einträge pro Seite',
					noResults: 'keine passenden Einträge gefunden',
					count: '{from} bis {to} von {count} Einträgen|{count} Einträge|ein Eintrag'
				},

				pagination: {
					chunk: 5
				},

				skin: 'table is-striped is-hoverable is-fullwidth',

				// custom filter functions
				customFilters: [
					{
						name: 'search',
						callback(row, string) {

							if(string == null || string == "") {
								return true;
							}

							string = string.toLowerCase();

							return row.name != null && row.name.toLowerCase().indexOf(string) > -1

						}
					},
				],

				rowClassCallback: function(row) {
					return `item row-${row.id}`
				}
			}
		}
	},

	created() {

		this.fetchData();

	},

	updated() {

		var self = this;
		$("table tbody > tr").unbind("click").on("click", function() {
			var temp = this.className.split("-")[1];
			var id = temp.split(" ")[0];
			// self.$router.push('/einstellungen/rubriken/rubrik-' + id);
			self.$router.push({name: 'settingsSectionsEdit', params: { sectionID: id }});
		});

	},

	watch: {

		searchString(val) {
			Event.$emit('vue-tables.tblSections.filter::search', val);
		},

	},

	methods: {

		fetchData() {

            this.isLoading = true;
            var self = this;
			var apiURL = this.$config.api + 'catalogSection?filters[catalog]='+self.catalogId+'&orderBy=sortorder';
			// var apiURL = this.$config.api + 'catalogSection?orderBy=sortorder&include=catalogSection.catalog,catalog.catalogPages&filters[catalogPage.sectionId]=5';

            // fetch data
            this.axios.get(apiURL)
                .then(function(response) {

					self.sections = response.data.catalogSection;
                    self.isLoading = false;

				}).catch(function(error) {
                    self.isLoading = false;
                    console.log('Error: ', error.message);
                });

        },

		_getSectionPages(sectionId, index) {

			var self = this;

			return new Promise(function(resolve, reject) {

				self.axios.get(self.$config.api + 'catalog?include=catalog.catalogPages&filters[catalogPages.section]='+ sectionId)
					.then(function(response) {
						resolve(response.data.catalog.length);
					});
			});



		},

        sectionDelete(props) {

			var self = this;
			var sectionId = props.row.id;

			this.axios.delete(this.$config.api + 'catalogSection/'+props.row.id)
				.then(function(response) {

					// find the corresponding section element and remove it from the sections array
					for(var i =0; i < self.sections.length; i++) {
						if(self.sections[i].id == sectionId) {
							self.sections.splice(i, 1);
						}
					}

					// self.sections.splice(props.index, 1);
					self.$notify.success({content: self.$t('MSG-SUCCESS-SECTION_DELETED') });
				})
				.catch(function(error) {
					// show success notify
					self.$notify.open({content: self.$t('MSG-ERROR-DATA_SAVE') + ': ' + error.message, type: 'danger'});
				});

		},

		sectionAdd() {
			// this.$router.push('/einstellungen/rubriken/neu');
			this.$router.push({name: 'settingsSectionsNew'});
		},

	}
}
</script>


<style>
/*
.drag-handle2 {
	width: 20px; height: 20px; line-height: 20px; display: inline-block; text-align: center; font-size: 14px; font-weight: bold;
}
*/
.sections thead th:last-child {
    width: 100px;
    text-align: center;
}
.sections td:last-child {
    text-align: center;
}

</style>
